import { createApp } from 'vue'
import i18n from '@gd/i18n'
import RegistrationForm from '@/apps/RegistrationForm.vue'
import PasswordForgottenForm from '@/apps/PasswordForgottenForm.vue'
import ChangePasswordForm from '@/apps/ChangePasswordForm.vue'
import ConvertGuestForm from '@/apps/ConvertGuestForm.vue'
import { loadTComponents } from '@gd/t-components'
import '@/styles/index.less'
import { LINK } from './model/LINK'

const registrationFormNode = document.getElementById('registration-form')
if (registrationFormNode) {
  const data = {
    actionURL: registrationFormNode.dataset.actionUrl,
    originalQuery: registrationFormNode.dataset.originalQuery,
    landingPageId: registrationFormNode.dataset.landingPageId,
    colorScheme: registrationFormNode.dataset.colorScheme,
  }

  const app = createApp(RegistrationForm, {
    actionURL: data.actionURL,
    originalQuery: data.originalQuery,
    landingPageId: data.landingPageId,
    colorScheme: data.colorScheme,
  }).use(i18n)

  loadTComponents(app)
  app.mount('#registration-form')
}

if (document.getElementById('password-forgotten-form')) {
  const app = createApp(PasswordForgottenForm).use(i18n)
  loadTComponents(app)
  app.mount('#password-forgotten-form')
}

if (document.getElementById('change-password-form')) {
  const app = createApp(ChangePasswordForm).use(i18n)
  loadTComponents(app)
  app.mount('#change-password-form')
}

export { RegistrationForm, PasswordForgottenForm, ChangePasswordForm, ConvertGuestForm, LINK }
